/**
 * @class Defines an authentification object.
 */
export class AuthentificationModel {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  /**
   * @constructor Creates an instance of an authentification object built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo: {
    access_token: string;
    expires_in: number;
    refresh_token: string;
  }) {
    this.accessToken = bo.access_token;
    this.expiresIn = bo.expires_in;
    this.refreshToken = bo.refresh_token;
  }
}
